import { useIntl } from "react-intl";
import { EmptyState } from "../../../components/EmptyState";
import { TWeatherForecast } from "./types";

const ForecastEmptyState: React.FC<TWeatherForecast> = (props) => {
  const intl = useIntl();
  return (<EmptyState
    header={intl.formatMessage({ id: "WeaterForecast.NoForecast", defaultMessage: 'No forecast available' })}
    message={intl.formatMessage({ id: "WeaterForecast.NoForecastDescr", defaultMessage: 'Forecast data will be refresh within next hour' })}></EmptyState>);
};

export default ForecastEmptyState;